import React from "react";
import { Link } from "react-scroll";
import { Parallax } from "react-parallax";
import { scrollDuration } from "../config/commonConfig";

const CallToAction = () => {
  return (
    <section>
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />
        <Parallax
          bgImage="images/intro-bg-2.jpg"
          bgImageAlt="Intro"
          strength={200}
        >
          <div className="hero-content section">
            <div className="container text-center py-5 wow fadeInUp">
              <h2 className="text-10 fw-600 text-white mb-5">
                Zainteresowany współpracą?
              </h2>
              <Link
                className="btn btn-primary rounded-0 smooth-scroll wow rubberBand"
                data-wow-delay="1s"
                smooth="easeInOutQuint"
                duration={scrollDuration}
                to="contact"
              >
                Wypełnij formularz!
              </Link>{" "}
              {/*
              <a
                href="https://www.instagram.com/makos.ky"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-light rounded-0 wow rubberBand"
                data-wow-delay="1.2s"
              >
                <i className="fab fa-instagram me-2" aria-hidden="true" />
                Zobacz kulisy mojej pracy!
              </a> */}
            </div>
          </div>
        </Parallax>
      </div>
    </section>
  );
};

export default CallToAction;